<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-contenido">
      <h4>{{ modo === 'modificar' ? 'Modificar indicador' : 'Agregar indicador' }}</h4>

      <!-- Clasificación de indicador -->
      <div class="formulario-opcion tipo-indicador-flex">
        <label :for="modo === 'agregar' ? 'tipoIndicador' : undefined">
          Clasificación de Indicador
          <small>(Documental, cuantitativo o de opinión)</small>
        </label>
        <template v-if="modo === 'agregar'">
          <div class="fila-select-boton">
            <select id="tipoIndicador" v-model="tipoIndicadorId" :disabled="loading">
              <option disabled value="">Seleccione una clasificación</option>
              <option
                v-for="t in tiposUnicos"
                :key="t.id_tipo_componente"
                :value="t.id_tipo_componente"
              >
                {{ t.nombre }}
              </option>
            </select>
            <button class="btn guardar" @click.prevent="mostrarNuevoTipo = !mostrarNuevoTipo">
              Nuevo Tipo
            </button>
          </div>
        </template>
        <template v-else>
          <div class="campo-fijo">{{ nombreTipoActual }}</div>
          <p class="nota-no-editable">Este campo no puede modificarse.</p>
        </template>
      </div>

      <!-- Formulario para crear nuevo tipo (solo al agregar) -->
      <div v-if="modo === 'agregar' && mostrarNuevoTipo" class="formulario-opcion nuevo">
        <div class="nuevo-header">
          <label for="nuevoTipoNombre">
            Nombre del nuevo tipo
            <small>(Seleccione la clasificación del indicador)</small>
          </label>
          <button type="button" class="nuevo-cerrar" @click="mostrarNuevoTipo = false; nuevoTipoNombre = ''">&times;</button>
        </div>
        <select id="nuevoTipoNombre" v-model="nuevoTipoNombre" :disabled="loading">
          <option disabled value="">Seleccione...</option>
          <option value="Información Documental">Información Documental</option>
          <option value="Información Cuantitativa">Información Cuantitativa</option>
          <option value="Información de Opinión">Información de Opinión</option>
        </select>
      </div>

      <!-- Unidad -->
      <div class="formulario-opcion tipo-indicador-flex">
        <label for="unidadIndicador">
          Unidad
          <small>(Seleccione una unidad o agregue una nueva)</small>
        </label>
        <div class="fila-select-boton">
          <select id="unidadIndicador" v-model="unidadIndicadorId" :disabled="loading">
            <option disabled value="">Seleccione una unidad</option>
            <option
              v-for="u in unidadesUnicas"
              :key="u.id_unidad"
              :value="u.nombre"
            >
              {{ u.nombre }}
            </option>
          </select>
          <button class="btn guardar" @click.prevent="mostrarNuevaUnidad = !mostrarNuevaUnidad">
            Nueva Unidad
          </button>
        </div>
      </div>

      <!-- Formulario para crear nueva unidad -->
      <div v-if="mostrarNuevaUnidad" class="formulario-opcion nuevo">
        <div class="nuevo-header">
          <label for="nuevaUnidadNombre">
            Ingrese la nueva unidad
            <small>(Ej: Porcentaje, Nivel, Índice)</small>
          </label>
          <button type="button" class="nuevo-cerrar" @click="mostrarNuevaUnidad = false; nuevaUnidadNombre = ''">&times;</button>
        </div>
        <input id="nuevaUnidadNombre" type="text" v-model="nuevaUnidadNombre" :disabled="loading"/>
      </div>

      <!-- Tipo Indicador -->
      <div class="formulario-opcion tipo-indicador-flex">
        <label for="nombreIndicador">
          Tipo Indicador
          <small>(Seleccione un tipo o agregue uno nuevo)</small>
        </label>
        <div class="fila-select-boton">
          <select id="nombreIndicador" v-model="nombreIndicadorId" :disabled="loading">
            <option disabled value="">Seleccione un tipo de indicador</option>
            <option
              v-for="n in nombresUnicos"
              :key="n.id_nombre"
              :value="n.nombre"
            >
              {{ n.nombre }}
            </option>
          </select>
          <button class="btn guardar" @click.prevent="mostrarNuevoNombre = !mostrarNuevoNombre">
            Nuevo Tipo
          </button>
        </div>
      </div>

      <!-- Panel para nuevo tipo de indicador -->
      <div v-if="mostrarNuevoNombre" class="formulario-opcion nuevo">
        <div class="nuevo-header">
          <label for="nuevoNombreIndicador">
            Ingrese el tipo de indicador
            <small>(Ej: De capacidad, proceso orientado al resultado, de logro)</small>
          </label>
          <button type="button" class="nuevo-cerrar" @click="mostrarNuevoNombre = false; nuevoNombreIndicador = ''">&times;</button>
        </div>
        <input id="nuevoNombreIndicador" type="text" v-model="nuevoNombreIndicador" :disabled="loading"/>
      </div>

      <!-- Fórmula -->
      <div class="formulario-opcion tipo-indicador-flex">
        <label for="formulaIndicador">
          Fórmula
          <small>(Seleccione una fórmula o agregue una nueva)</small>
        </label>
        <div class="fila-select-boton">
          <select id="formulaIndicador" v-model="formulaIndicadorId" :disabled="loading">
            <option disabled value="">Seleccione una fórmula</option>
            <option
              v-for="f in formulasUnicas"
              :key="f.id_formula"
              :value="f.nombre"
            >
              {{ f.nombre }}
            </option>
          </select>
          <button class="btn guardar" @click.prevent="mostrarNuevaFormula = !mostrarNuevaFormula">
            Nueva Fórmula
          </button>
        </div>
      </div>

      <!-- Formulario para crear nueva fórmula -->
      <div v-if="mostrarNuevaFormula" class="formulario-opcion nuevo">
        <div class="nuevo-header">
          <label for="nuevaFormulaNombre">
            Nombre de la nueva fórmula
            <small>(Ej: (Logros/Metas)*100)</small>
          </label>
          <button type="button" class="nuevo-cerrar" @click="mostrarNuevaFormula = false; nuevaFormulaNombre = ''">&times;</button>
        </div>
        <input id="nuevaFormulaNombre" type="text" v-model="nuevaFormulaNombre" :disabled="loading"/>
      </div>

      <!-- Descripción -->
      <div class="formulario-opcion">
        <label for="descripcionIndicador">
          Descripción
          <small>(Opcional)</small>
        </label>
        <textarea id="descripcionIndicador" v-model="descripcionIndicador" :disabled="loading"></textarea>
      </div>

      <!-- Botones -->
      <div class="botones">
        <button class="btn salir" @click="cancelar" :disabled="loading">Cancelar</button>
        <button class="btn guardar" @click="emitirAceptar" :disabled="loading || !puedeAceptar">
          {{ loading ? 'Guardando…' : 'Aceptar' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
/**
 * Formulario de alta y edición de un indicador.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

import { ref, computed, watch } from 'vue'
import type TipoComponente from '@/interfaces/TipoComponente'

interface UnidadItem { id_unidad: number; nombre: string }
interface FormulaItem { id_formula: number; nombre: string; clasificacion?: string }
interface NombreItem { id_nombre: number; nombre: string }

const props = defineProps<{
  visible: boolean
  modo: 'agregar' | 'modificar'
  loading: boolean
  tiposDisponibles: TipoComponente[]
  unidadesDisponibles: UnidadItem[]
  formulasDisponibles: FormulaItem[]
  nombresDisponibles: NombreItem[]
  // Valores iniciales para edición
  tipoInicial?: number | ''
  nombreInicial?: string
  unidadInicial?: string
  formulaInicial?: string
  descripcionInicial?: string
}>()

const emit = defineEmits<{
  (e: 'aceptar', payload: {
    tipoIndicadorId: number | ''
    nuevoTipoNombre: string
    nombreIndicador: string
    unidadIndicadorId: string
    nuevaUnidadNombre: string
    formulaIndicadorId: string
    nuevaFormulaNombre: string
    descripcionIndicador: string
  }): void
  (e: 'cancelar'): void
}>()

const tipoIndicadorId = ref<number | ''>('')
const mostrarNuevoTipo = ref(false)
const nuevoTipoNombre = ref('')

const nombreIndicadorId = ref('')
const mostrarNuevoNombre = ref(false)
const nuevoNombreIndicador = ref('')
const descripcionIndicador = ref('')

const unidadIndicadorId = ref('')
const mostrarNuevaUnidad = ref(false)
const nuevaUnidadNombre = ref('')

const formulaIndicadorId = ref('')
const mostrarNuevaFormula = ref(false)
const nuevaFormulaNombre = ref('')

// Cuando se abre el modal, inicializar los campos
watch(() => props.visible, (val) => {
  if (val) {
    tipoIndicadorId.value = props.tipoInicial ?? ''
    nombreIndicadorId.value = props.nombreInicial ?? ''
    unidadIndicadorId.value = props.unidadInicial ?? ''
    formulaIndicadorId.value = props.formulaInicial ?? ''
    descripcionIndicador.value = props.descripcionInicial ?? ''
    mostrarNuevoTipo.value = false
    nuevoTipoNombre.value = ''
    mostrarNuevoNombre.value = false
    nuevoNombreIndicador.value = ''
    mostrarNuevaUnidad.value = false
    nuevaUnidadNombre.value = ''
    mostrarNuevaFormula.value = false
    nuevaFormulaNombre.value = ''
  }
})

watch(tipoIndicadorId, (nuevoId) => {
  if (nuevoId) {
    mostrarNuevoTipo.value = false
    nuevoTipoNombre.value = ''
  }
})

const nombreTipoActual = computed(() => {
  if (!props.tipoInicial) return '—'
  const tipo = props.tiposDisponibles.find(t => t.id_tipo_componente === props.tipoInicial)
  return tipo?.nombre ?? '—'
})

// Filtrar opciones duplicadas por nombre
const tiposUnicos = computed(() => {
  const vistos = new Set<string>()
  return props.tiposDisponibles.filter(t => {
    const nombre = (t.nombre ?? '').trim().toLowerCase()
    if (vistos.has(nombre)) return false
    vistos.add(nombre)
    return true
  })
})

const unidadesUnicas = computed(() => {
  const vistos = new Set<string>()
  return props.unidadesDisponibles.filter(u => {
    const nombre = (u.nombre ?? '').trim().toLowerCase()
    if (vistos.has(nombre)) return false
    vistos.add(nombre)
    return true
  })
})

// Clasificación derivada del tipo actualmente seleccionado o del nuevo tipo en edición
const clasificacionActual = computed(() => {
  if (mostrarNuevoTipo.value && nuevoTipoNombre.value.trim()) {
    const n = nuevoTipoNombre.value.toLowerCase()
    if (/document/.test(n)) return 'documental'
    if (/cuantitativ/.test(n)) return 'cuantitativa'
    if (/opini/.test(n)) return 'opinion'
    return ''
  }
  if (!tipoIndicadorId.value) return ''
  const tipo = props.tiposDisponibles.find(t => t.id_tipo_componente === tipoIndicadorId.value)
  const n = (tipo?.nombre ?? '').toLowerCase()
  if (/document/.test(n)) return 'documental'
  if (/cuantitativ/.test(n)) return 'cuantitativa'
  if (/opini/.test(n)) return 'opinion'
  return ''
})

const formulasUnicas = computed(() => {
  const base = clasificacionActual.value
    ? props.formulasDisponibles.filter(f => f.clasificacion === clasificacionActual.value)
    : props.formulasDisponibles
  const vistos = new Set<string>()
  return base.filter(f => {
    const nombre = (f.nombre ?? '').trim().toLowerCase()
    if (vistos.has(nombre)) return false
    vistos.add(nombre)
    return true
  })
})

// Limpiar fórmula seleccionada cuando cambia la clasificación y ya no está en la lista
watch(clasificacionActual, () => {
  if (!formulaIndicadorId.value || !clasificacionActual.value) return
  const sigueDisponible = formulasUnicas.value.some(f => f.nombre === formulaIndicadorId.value)
  if (!sigueDisponible) formulaIndicadorId.value = ''
})

const nombresUnicos = computed(() => {
  const vistos = new Set<string>()
  return props.nombresDisponibles.filter(n => {
    const nombre = (n.nombre ?? '').trim().toLowerCase()
    if (vistos.has(nombre)) return false
    vistos.add(nombre)
    return true
  })
})

watch(nombreIndicadorId, (val) => {
  if (val) {
    mostrarNuevoNombre.value = false
    nuevoNombreIndicador.value = ''
  }
})

const puedeAceptar = computed(() => {
  const tipoValido = mostrarNuevoTipo.value
    ? !!nuevoTipoNombre.value.trim()
    : !!tipoIndicadorId.value

  const unidadValida =
    (mostrarNuevaUnidad.value && !!nuevaUnidadNombre.value.trim()) ||
    (!!unidadIndicadorId.value && !mostrarNuevaUnidad.value)

  const formulaValida =
    (mostrarNuevaFormula.value && !!nuevaFormulaNombre.value.trim()) ||
    (!!formulaIndicadorId.value && !mostrarNuevaFormula.value)

  const nombreValido = mostrarNuevoNombre.value
    ? !!nuevoNombreIndicador.value.trim()
    : !!nombreIndicadorId.value

  return tipoValido && unidadValida && formulaValida && nombreValido
})

function cancelar() {
  emit('cancelar')
}

function emitirAceptar() {
  if (!puedeAceptar.value) return
  emit('aceptar', {
    tipoIndicadorId: tipoIndicadorId.value,
    nuevoTipoNombre: nuevoTipoNombre.value,
    nombreIndicador: mostrarNuevoNombre.value ? nuevoNombreIndicador.value.trim() : nombreIndicadorId.value,
    unidadIndicadorId: unidadIndicadorId.value,
    nuevaUnidadNombre: nuevaUnidadNombre.value,
    formulaIndicadorId: formulaIndicadorId.value,
    nuevaFormulaNombre: nuevaFormulaNombre.value,
    descripcionIndicador: descripcionIndicador.value?.trim() || ''
  })
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal-contenido {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  max-width: 620px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.formulario-opcion {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
  margin-bottom: 1rem;
}

input,
textarea {
  padding: 0.75rem;
  border: 1px solid #e6e5e5;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
  border-radius: var(--radius-md);
  font-size: 1rem;
  background-color: #f9f9f9;
  margin-bottom: 6px;
}

.botones {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
}

.btn {
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.btn.salir {
  background-color: white;
  border: 1px solid #ccc;
}

.btn.salir:hover {
  background-color: rgb(212, 26, 26);
  color: white;
}

.btn.guardar {
  background-color: #eea222;
  color: black;
}

.btn.guardar:hover {
  background-color: #0e69a0;
  cursor: pointer;
  color: white;
}

label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
}

label small {
  font-weight: normal;
  font-size: 0.85em;
  color: #666;
  margin-left: 4px;
}

select {
  padding: 0.75rem;
  padding-bottom: 12px;
  border: 1px solid #e6e5e5;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
  border-radius: var(--radius-md);
  font-size: 1rem;
  background-color: #f9f9f9;
  margin-bottom: 6px;
}

.fila-select-boton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  width: 100%;
}

.fila-select-boton select {
  flex: 1;
  min-width: 250px;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
}

.fila-select-boton button {
  white-space: nowrap;
}

.formulario-opcion.nuevo {
  background: linear-gradient(135deg, #fff7e6, #fff3d1);
  border: 2px solid #eea222;
  border-radius: 8px;
  padding: 1rem;
  animation: fadeIn 0.3s ease-in-out;
}

.formulario-opcion.nuevo label {
  color: #0e69a0;
  font-weight: 600;
}

.nuevo-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
}

.nuevo-cerrar {
  background: none;
  border: none;
  font-size: 1.3rem;
  line-height: 1;
  color: #aaa;
  cursor: pointer;
  padding: 0 2px;
  flex-shrink: 0;
  margin-top: 1px;
  transition: color 0.15s;
}

.nuevo-cerrar:hover {
  color: #d41a1a;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
}
input:focus, select:focus, textarea:focus {
  outline: none;
  border-color: #0e69a0;
  box-shadow: 0 0 0 3px rgba(14, 105, 160, 0.1);
}

.campo-fijo {
  padding: 0.6rem 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: var(--radius-md);
  background: #f3f3f3;
  font-size: 1rem;
  color: #444;
  cursor: default;
}

.nota-no-editable {
  margin: 0;
  font-size: 0.78rem;
  color: #888;
  font-style: italic;
}
</style>
